import styled from 'styled-components';
import COLORS from '../../constants/colors.js';

const FileInputWrapper = styled.div `
    border: 2px dashed ${COLORS.GREY_400};
    border-radius: 4px;

    label {
        cursor: pointer;
        margin: 0;
        display: block;
        &:focus-within {
            outline: none;
        }
    }
`;
const FileInputPreviewer = styled.img `
    max-width: 100%;
    max-height: 240px;
`;

export { FileInputPreviewer, FileInputWrapper };
//# sourceMappingURL=FileInput.styles.js.map
